import { useEffect, useState, useContext } from '@wordpress/element';
import classNames from 'classnames';
import AreaCanvas from '@components/AreaCanvas/AreaCanvas';
import {
  InnerBlocks,
  useInnerBlocksProps,
  useBlockProps,
  InspectorControls,
  BlockControls,
} from '@wordpress/block-editor';

export default function Edit({ attributes, setAttributes, clientId }) {
  const {
    media,
    mediaStyle,
    mediaClass,
    pageId,
    flexStyle,
    flexClass,
    bitePreset,
  } = attributes;

  const mediaStyleSettings = [];
  const biteBlockClass = ['bf_layout', flexClass];
  const biteBlockClasses = biteBlockClass.join(' ');
  const { children, ...innerBlocksProps } = useInnerBlocksProps({
    className: `${biteBlockClasses}`,
  });

  const blockProps = useBlockProps();

  // const screen = useContext(BiteContext);
  // console.log(screen, "useContext");

  return (
    <div {...blockProps}>
      <div {...innerBlocksProps}>{children}</div>
      <AreaCanvas
        screen={screen}
        flexStyle={flexStyle}
        className={biteBlockClasses}
        clientId={clientId}
      />
    </div>
  );
}
